import { type ReactNode } from "react";
import styles from "./accordion-body.module.css";
import {
  useAccordionItem,
  useAccordionTransitionEnabled,
} from "./hooks";

export type AccordionBodyProps = {
  children: ReactNode;
} & React.AllHTMLAttributes<HTMLDivElement>;

export function AccordionBody({ children, ...props }: AccordionBodyProps) {
  const { isOpen, openedByDefault } = useAccordionItem();
  const transitionEnabled = useAccordionTransitionEnabled(openedByDefault);

  return (
    <div
      className={styles.Main}
      style={{
        ...(transitionEnabled ? {} : { transition: "none" }),
      }}
      {...props}
      data-open={isOpen ? "true" : undefined}
      data-transition-ready={transitionEnabled ? "true" : "false"}
    >
      <div className={styles.Content}>{children}</div>
    </div>
  );
}
